module.exports = __webpack_public_path__ + "static/media/master.fc730f54.png";